import { InjectionToken } from '@angular/core';

export const FIVE_MINUTES_IN_MILLIS = 5 * 60 * 1000;
export const PROFILE_CACHE_TIME = new InjectionToken<number>('PROFILE_CACHE_TIME');
